import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label,Form } from "reactstrap";
import { useHistory } from "react-router-dom";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Geocode from "react-geocode";
import { ProfileService } from "../../../../../services/ProfileService";
import { ENV } from "../../../../../config/ENV";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  formattedMobileNumber,
  getPhoneNumberByCountryCode,
  validatePhoneNumber,
  getMobileNumberCountryCode,
  getCountryCodefromMobile,
} from "../../../../../utilities/phonenumberutility";
import { Stringutility } from "../../../../../utilities/stringutility";
import { StorageService } from "../../../../../services/StorageService";
import { StorageValues } from "../../../../../constants/storageValues";
import { APIResposneService } from "../../../../../services/APIResponseService";
import { Constants } from "../../../../../constants/constantValues";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
Geocode.setApiKey(ENV.google_api_key);

const BasicInfo = () => {
  const history = useHistory();
  const [prefContacts, setprefContacts] = useState("");
  const [prefContactTime, setprefContactTime] = useState("");
  const [workAuthorization, setWorkAuthorization] = useState("");
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);

  const [month, setmonth] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const [birthMonth, setbirthMonth] = useState("");
  const [jobprefContactTimeoptions, setjobprefContactTimeoptions] = useState(
    []
  );
  const [jobprefContactsoption, setjobprefContactsoption] = useState([]);
  const [secondaryNumber, setSecondaryNumber] = useState("");

  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    namePreference: "",
    birthday: "",
    email: "",
    primaryPhone: "",
    // secondaryNumber: "",
    additionalPublicInfoDesc: "",
    internalNoteDesc: "",
    zipCode: "",
    prefContactMethod: "",
    position: "",
  });

  const [secondaryMobileNumber, setSecondaryMoblieNumber] = useState("");
  const [
    secondaryMobileNumberCountryCode,
    setSecondaryMobileNumberCountryCode,
  ] = useState("1");

  const handlePhoneNumber = (value, country) => {
    setSecondaryNumber(value);

    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);

      setSecondaryMobileNumberCountryCode(dialCode);
      setSecondaryMoblieNumber(mobileNumber);
    }
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleWorkAuthSelectChange = (e) => {
    setWorkAuthorization(e.target.value);
  };
  const handleprefContactTime = (e) => {
    setprefContactTime(e.target.value);
  };
  const handleprefContact = (e) => {
    setprefContacts(e.target.value);
  };
  const handlemonth = (e) => {
    setbirthMonth(e.target.value);
  };

  let count = 0;
  useEffect(() => {
    if (window.localStorage.getItem("enumsLists")!=null) {
      var enumsLists = JSON.parse(window.localStorage.getItem("enumsLists"));
      if (enumsLists.prefContactTimes !== null) {
        setjobprefContactTimeoptions(enumsLists.prefContactTimes);
      }
      if (enumsLists.prefContacts != null) {
        setjobprefContactsoption(enumsLists.prefContacts);
      }
    }
    setInputField((prevState) => ({
      ...prevState,
      firstName: Stringutility.getValue(
        StorageService.getFromLocalStorage(StorageValues.NAME)
      ),
      lastName: Stringutility.getValue(
        StorageService.getFromLocalStorage(StorageValues.LASTNAME)
      ),
      email: Stringutility.getValue(
        StorageService.getFromLocalStorage(StorageValues.EMAIL)
      ),
      primaryPhone: Stringutility.getValue(
        StorageService.getFromLocalStorage(StorageValues.CONTACT_NUMBER)
      ),
    }));
    getCandidateBasicInfoDetails();
  }, [count]);

  const getCandidateBasicInfoDetails = () => {
    ProfileService.getBasicInfo().then((response) => {
      try {
        if (response.data !== null) {
          var basicInfoDetails = response.data;        
          var basicInfoResponse =
          APIResposneService.getBasicInfoResponse(basicInfoDetails);
          setWorkAuthorization(basicInfoResponse.workAuthorization);
          setInputField((prevState) => ({
            ...prevState,
            firstName: basicInfoResponse.firstName,
            middleName: basicInfoResponse.middleName,
            lastName: basicInfoResponse.lastName,
            namePreference: basicInfoResponse.namePreference,
            email: basicInfoResponse.email,
            primaryPhone: basicInfoResponse.contactNumber,
            internalNoteDesc: basicInfoResponse.internalNote,
            additionalPublicInfoDesc: basicInfoDetails.adlPublicInfo
          }));

          if (!Stringutility.isNullOrEmpty(basicInfoResponse.birthMonth)) {
            setbirthMonth(basicInfoResponse.birthMonth);
          }

          if (basicInfoResponse.birthDay !== 0) {
            setInputField((prevState) => ({
              ...prevState,
              birthday: basicInfoDetails.birthDay,
            }));
          }
          setSecondaryNumber(basicInfoResponse.secondaryNumber);

          if (!Stringutility.isNullOrEmpty(basicInfoResponse.secondaryNumber)) {
            setSecondaryNumber(basicInfoResponse.secondaryNumber);

           let countryCode = getCountryCodefromMobile(basicInfoResponse.secondaryNumber);
              setSecondaryMobileNumberCountryCode(countryCode);
              let mobileNumber = getMobileNumberCountryCode(
                basicInfoResponse.secondaryNumber
              );
              setSecondaryMoblieNumber(mobileNumber);
          }
          setprefContactTime(basicInfoResponse.prefContactTime);
          setprefContacts(basicInfoResponse.prefContactMethod);
        }
      } catch (err) {
        console.error("getBasicInfo" + JSON.stringify(err));
      }
    });
  };

  const handleCancelButton=()=>{
    history.push("/smartresume");
  }

  const submitButton = () => {
    if (Stringutility.isNullOrEmpty(inputField.firstName)) {
      Stringutility.showErrorMessage(Constants.enterFirstName);
      return;
    }

    if (Stringutility.isNullOrEmpty(inputField.lastName)) {
      Stringutility.showErrorMessage(Constants.enterLastName);
      return;
    }

    if (Stringutility.isNullOrEmpty(birthMonth)) {
      Stringutility.showErrorMessage(Constants.selectBirthMonth);
      return;
    }

    if (inputField.birthday == "") {
      Stringutility.showErrorMessage(Constants.enterDayOfMonth);
      return;
    }

    if (inputField.birthday !== 0) {
      if (
        birthMonth === "January" ||
        birthMonth === "March" ||
        birthMonth === "May" ||
        birthMonth === "July" ||
        birthMonth === "August" ||
        birthMonth === "October" ||
        birthMonth === "December"
      ) {
        if (
          !new RegExp("^(0?[1-9]|[12][0-9]|3[01])$").test(inputField.birthday)
        ) {
          Stringutility.showErrorMessage(Constants.enterDayOfMonth);
          return;
        }
      } else if (birthMonth === "February") {
        if (!new RegExp("^(0?[1-9]|[12][0-9])$").test(inputField.birthday)) {
          Stringutility.showErrorMessage(Constants.enterDayOfFebMonth);
          return;
        }
      } else {
        if (
          !new RegExp("^(0?[1-9]|[12][0-9]|3[0])$").test(inputField.birthday)
        ) {
          Stringutility.showErrorMessage(Constants.enterDayOfEvenMonth);
          return;
        }
      }
    } else {
       Stringutility.showErrorMessage(Constants.enterDayOfMonth);
      return;
    }

    if (Stringutility.isNullOrEmpty(inputField.email)) {
      Stringutility.showErrorMessage(Constants.enterEmail);
      return;
    }

    if (Stringutility.isNullOrEmpty(inputField.primaryPhone)) {
      Stringutility.showErrorMessage(Constants.enterPrimaryPhoneNumber);
      return;
    }

    let _secondaryMobileNumber = "";
    if (!Stringutility.isNullOrEmpty(secondaryMobileNumber)) {
      if (
        !validatePhoneNumber(
          secondaryMobileNumber,
          "+" + secondaryMobileNumberCountryCode
        )
      ) {
        Stringutility.showErrorMessage(Constants.enterValidSecondaryPhoneNumber);
        return;
      } else {
        _secondaryMobileNumber =
          secondaryMobileNumberCountryCode + "-" + secondaryMobileNumber;
      }
    }
    const candidateBasicInfoRequest = {
      firstName: inputField.firstName,
      middleName: inputField.middleName,
      lastName: inputField.lastName,
      namePreference: inputField.namePreference,
      birthMonth: birthMonth,
      birthDay: inputField.birthday,
      email: inputField.email,
      contactNumber: inputField.primaryPhone,
      secondaryNumber: _secondaryMobileNumber,
      workAuthorization: workAuthorization,
      prefContactTime: prefContactTime,
      prefContactMethod: prefContacts,
      adlPublicInfo: inputField.additionalPublicInfoDesc,
      internalNote: inputField.internalNoteDesc,
      skills: [],
    };
    setSaveBtnEnabled(true);
    ProfileService.updateBasicInfo(candidateBasicInfoRequest).then(
      (response) => {
        setSaveBtnEnabled(false);
        try {
          if (response.data !== null) {
            StorageService.saveInLocalStorage(StorageValues.NAME,inputField.firstName);
            StorageService.saveInLocalStorage(StorageValues.LASTNAME,inputField.lastName);
            // setTimeout(
            //   function () {
                window.location.href = ENV.candidate_web_url + "basicinfo";
            //   }.bind(this),
            //   1000
            // );
          }
        } catch (err) {
          console.error("updateBasicInfo " + err.message);
        }
      }
    );
  };

  return (
    <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">

                   
                    
                    <div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
          <div className="col-sm-12">
            <div className="">
              <div className="addexperience right">
                <div className="skill-header">
                  <div>
                    <div className="profile-card-title">
                      <label className="t-h2-font-sm">
                        <strong>Basic Info</strong>
                      </label>
                      <div className="horizontal_line" />
                    </div>
                  </div>
                </div>

                <Form className="mt-4">
                  <FormGroup row>
                    <Label sm={3}>Name*</Label>
                    <Colxx sm={3}>
                      <Input
                        className="t-rounded-lg"
                        type="text"
                        name="firstName"
                        data-testid="basicinfo-firstName"
                        placeholder="First Name"
                        onChange={inputsHandler}
                        disabled={false}
                        value={inputField.firstName}
                      />
                    </Colxx>
                    <Colxx sm={3}>
                      <Input
                        type="text"
                        className="t-rounded-lg t-sal-margin-top"
                        name="middleName"
                        data-testid="basicinfo-middleName"
                        placeholder="Middle Name"
                        onChange={inputsHandler}
                        value={inputField.middleName}
                      />
                    </Colxx>
                    <Colxx sm={3}>
                      <Input
                        type="text"
                        className="t-rounded-lg t-sal-margin-top"
                        name="lastName"
                        data-testid="basicinfo-lastName"
                        placeholder="Last Name"
                        onChange={inputsHandler}
                        disabled={false}
                        value={inputField.lastName}
                      />
                    </Colxx>
                  </FormGroup>
                  <FormGroup row>
                    <Label sm={3}>Name Preference</Label>
                    <Colxx sm={6}>
                      <Input
                        type="text"
                        className="t-rounded-lg"
                        name="namePreference"
                        data-testid="basicinfo-namePreference"
                        placeholder="Preference"
                        onChange={inputsHandler}
                        value={inputField.namePreference}
                      />
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Birth Date*</Label>
                    <Colxx sm={3}>
                      <Input
                        type="select"
                        className="t-rounded-lg"
                        value={birthMonth}
                        id="birthMonth"
                        onChange={handlemonth}
                      >
                        <option value="">Select month</option>
                        {month.map((value) => (
                          <option value={value} key={value}>
                            {value}
                          </option>
                        ))}
                      </Input>
                    </Colxx>

                    <Colxx sm={3}>
                      <Input
                        type="text"
                        className="t-rounded-lg t-sal-margin-top"
                        name="birthday"
                        data-testid="basicinfo-birthday"
                        id="birthday"
                        placeholder="Birth date"
                        onChange={inputsHandler}
                        value={inputField.birthday}
                      ></Input>
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Email Address*</Label>
                    <Colxx sm={6}>
                      <Input
                        type="email"
                        className="t-rounded-lg"
                        name="email"
                        data-testid="basicinfo-email"
                        placeholder="Email"
                        disabled={true}
                        onChange={inputsHandler}
                        value={inputField.email}
                      />
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Primary Phone*</Label>
                    <Colxx sm={6}>
                      <Input
                        type="text"
                        className="t-rounded-lg"
                        name="primaryPhone"
                        data-testid="basicinfo-primaryPhone"
                        placeholder="Phone number"
                        onChange={inputsHandler}
                        disabled={true}
                        value={formattedMobileNumber(inputField.primaryPhone)}
                      />
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Secondary Phone </Label>
                    <Colxx sm={6}>
                      <PhoneInput
                        country="us"
                        // regions={['north-america']}
                        countryCodeEditable={false}
                        type="text"
                        className="t-rounded-lg"
                        name="secondaryNumber"
                        data-testid="basicinfo-secondaryNumber"
                        placeholder="Phone number"
                        // onChange={(e) => handlePhoneNumber(e)}
                        onChange={handlePhoneNumber}
                        value={secondaryNumber}
                      />
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Preferred Contact </Label>
                    <Colxx sm={3}>
                      <Input
                        type="select"
                        className="t-rounded-lg "
                        value={prefContactTime}
                        id="prefContactTime"
                        onChange={handleprefContactTime}
                      >
                        <option value="">Select time</option>
                        {jobprefContactTimeoptions.length > 0 &&
                          jobprefContactTimeoptions.map(({ value, key }) => (
                            <option value={key} key={key}>
                              {value}
                            </option>
                          ))}
                      </Input>
                    </Colxx>

                    <Colxx sm={3}>
                      <Input
                        type="select"
                        className="t-rounded-lg t-sal-margin-top"
                        value={prefContacts}
                        id="prefContacts"
                        onChange={handleprefContact}
                      >
                        <option value="">Select method</option>
                        {jobprefContactsoption.length > 0 &&
                          jobprefContactsoption.map(({ value, key }) => (
                            <option value={key} key={key}>
                              {value}
                            </option>
                          ))}
                      </Input>
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={4} className="profile-card-subtitle mt-1">
                      <strong>Employability</strong>
                    </Label>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Work Authorization*</Label>
                    <Colxx sm={6}>
                      <Input
                        className="t-rounded-lg"
                        value={workAuthorization}
                        type="select"
                        onChange={handleWorkAuthSelectChange}
                      >
                        <option value="USA_WORK" key="USA_WORK">
                          I have authorization to work in USA
                        </option>
                        <option value="NEED_SPONSORSHIP" key="NEED_SPONSORSHIP">
                          I will need employer sponsorship
                        </option>
                      </Input>
                    </Colxx>
                  </FormGroup>
                  <FormGroup row>
                    <Label sm={4} className="profile-card-subtitle mt-1">
                      <strong>Additional Info</strong>
                    </Label>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Additional Public Info</Label>
                    <Colxx sm={8}>
                      <Input
                        rows="4"
                        className="t-rounded-lg"
                        data-testid="basicinfo-additionalPublicInfoDesc"
                        type="textarea"
                        maxLength="255"
                        name="additionalPublicInfoDesc"
                        onChange={inputsHandler}
                        value={inputField.additionalPublicInfoDesc}
                        placeholder="This is seen by the hiring team"
                      />
                    </Colxx>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm={3}>Internal Note to Recruiting Team</Label>
                    <Colxx sm={8}>
                      <Input
                        rows="4"
                        className="t-rounded-lg"
                        data-testid="basicinfo-internalNoteDesc"
                        type="textarea"
                        name="internalNoteDesc"
                        placeholder="Internal use only"
                        onChange={inputsHandler}
                        maxLength="255"
                        value={inputField.internalNoteDesc}
                      />
                    </Colxx>
                  </FormGroup>
                </Form>

                <div className="mt-5">
                  <TeamanicsButton
                    onClick={handleCancelButton}
                  >
                    Cancel
                  </TeamanicsButton>
                  <TeamanicsButton
                    className="ml-2"
                    onClick={submitButton}
                    disabled={saveBtnEnabled}
                  >
                    Save
                  </TeamanicsButton>
                </div>
                <div className="mb-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
 
  );
};

export default BasicInfo;
